// import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import React, { useState, useEffect } from "react";
// import TableChartIcon from "@mui/icons-material/TableChart";
import "jspdf-autotable";
import GaugeChart from "react-gauge-chart";
import { useSelector } from "react-redux";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import { ChartColumnDecreasing } from "lucide-react"
import { TableOfContents } from "lucide-react"
import { ValidDate } from "../../../../../utils/DateUtils";

const SearchedSalesNetMargin = ({
  selectedYears,
  perdiem,
  averagecost,
  quotationProjects,
  calculatedProjects,
  packages,
  searchedLeadReports,
  searchedLeadReportswithoutyears,
  showTable,
  getProjectCost,
  getActualProjectCost,
  getRowKey,
  currentEmployee,
  filterVersion,
  canViewNetMarginGraph = true,
  canViewNetMarginTable = true,
  canViewYtdNetMarginGraph = true,
  canViewYtdNetMarginTable = true,
  /** P&L-aligned totals (ERP + Quoted on Sales Finance): same bases as Total / YTD Gross Profit cards. */
  erpPlGrossProfitSumForCard,
  erpPlValueSumForCard,
  erpPlCostSumForCard,
  erpPlYtdGrossProfitForNetMargin,
  erpPlYtdQuotedValueForNetMargin,
  erpPlYtdProductCostForNetMargin,
  /** Optional (CRM): final P&L table rows + accessors to match Total Gross Profit card. */
  plGetQuotedValueForRow,
  plGetQuotedExpenseForRow,
}) => {

  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const pkgNormalized = String(packages || "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
  const isCrmPackage =
    pkgNormalized === "crm" ||
    pkgNormalized.includes("crm");
  const parseExpenseValue = (v) => parseFloat(String(v || "0").replace(/[^0-9.-]/g, "")) || 0;

  const formatPct = (v) => {
    const n = Number(v);
    if (!Number.isFinite(n)) return "";
    // Percent values must not be rounded to whole numbers in the UI.
    return n.toFixed(2);
  };

  const [filteredLeadByYear, setFilteredLeadByYear] = useState([])
  const [ytdtotalProductCostCurrent, setYTDtotalProductCostCurrent] = useState("");
  const [totalProductCost, settotalProductCost] = useState();

  // useEffect(() => {

  //   const normalizedYears = selectedYears?.map(Number);

  //   const filteredLeadsByYear = searchedLeadReports?.filter((lead) => {
  //     const leadYear = new Date(lead.LeadDate).getFullYear();
  //     return normalizedYears?.includes(leadYear);
  //   });

  //   const today = new Date();
  //   const currentMonth = today.getMonth(); // 0-based
  //   const currentDate = today.getDate();

  //   const ytdFilteredLeads = filteredLeadsByYear?.filter((lead) => {
  //     const leadDate = new Date(lead.LeadDate);
  //     const leadYear = leadDate.getFullYear();

  //     const startDate = new Date(leadYear, 0, 1); // Jan 1 of lead year
  //     const endDate = new Date(leadYear, currentMonth, currentDate); // same MM-DD as today in that year

  //     return leadDate >= startDate && leadDate <= endDate;
  //   });

  //   setFilteredLeadByYear(ytdFilteredLeads)
  // }, [searchedLeadReports, selectedYears])


  useEffect(() => {
    const baseLeads = searchedLeadReportswithoutyears || [];

    if (!selectedYears || selectedYears.length === 0) {
      setFilteredLeadByYear(baseLeads);
      return;
    }

    const selectedPeriod = String(selectedYears?.[0] ?? "").trim();
    const yearOnlyMatch = selectedPeriod.match(/^(\d{4})$/);
    const monthMatch = selectedPeriod.match(/^(\d{4})\s+([A-Za-z]+)$/);
    const quarterMatch = selectedPeriod.match(/^(\d{4})\s+([A-Za-z]+)\s*-\s*([A-Za-z]+)$/);

    const selectedYear =
      yearOnlyMatch?.[1] ? Number(yearOnlyMatch[1]) :
        monthMatch?.[1] ? Number(monthMatch[1]) :
          quarterMatch?.[1] ? Number(quarterMatch[1]) :
            null;

    if (!selectedYear) {
      setFilteredLeadByYear(baseLeads);
      return;
    }

    const endOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);

    let startDate = new Date(selectedYear, 0, 1);
    let endDate;

    if (monthMatch) {
      const mIdx = getMonthIndex(monthMatch[2]);
      if (mIdx !== -1) {
        startDate = new Date(selectedYear, mIdx, 1);
        endDate = endOfDay(new Date(selectedYear, mIdx + 1, 0));
      }
    } else if (quarterMatch) {
      const startIdx = getMonthIndex(quarterMatch[2]);
      const endIdx = getMonthIndex(quarterMatch[3]);
      if (startIdx !== -1 && endIdx !== -1) {
        startDate = new Date(selectedYear, startIdx, 1);
        endDate = endOfDay(new Date(selectedYear, endIdx + 1, 0));
      }
    }

    if (!endDate) {
      endDate = endOfDay(new Date(selectedYear, 11, 31));
    }

    // CRM requirement: year-only selections should reflect the full year (no cap at today),
    // so Total and YTD cards match for the current year.
    let rangeEnd = endDate;

    const parseLeadDate = (lead) => {
      const raw = lead?.LeadDate ?? lead?.leadDate;
      if (!raw) return null;
      const normalized = ValidDate(raw);
      if (normalized) {
        const [y, m, d] = normalized.split("-").map(Number);
        const dt = new Date(y, m - 1, d);
        return isNaN(dt.getTime()) ? null : dt;
      }
      const dt = new Date(raw);
      return isNaN(dt.getTime()) ? null : dt;
    };

    console.log("[YTD NM DEBUG] selectedPeriod:", selectedPeriod, "startDate:", startDate.toISOString(), "endDate:", endDate.toISOString(), "rangeEnd:", rangeEnd.toISOString());
    console.log("[YTD NM DEBUG] baseLeads count:", baseLeads.length, "sample LeadDates:", baseLeads.slice(0, 3).map(l => l.LeadDate));

    const ytdLeads = baseLeads.filter((lead) => {
      const leadDate = parseLeadDate(lead);
      if (!leadDate) {
        console.warn("[YTD NM DEBUG] Unparseable LeadDate:", JSON.stringify(lead?.LeadDate ?? lead?.leadDate), "for", lead.ProjectName);
        return false;
      }
      const inRange = leadDate >= startDate && leadDate <= rangeEnd;
      if (!inRange) {
        console.log("[YTD NM DEBUG] Excluded:", lead.ProjectName, "raw:", lead.LeadDate, "parsed:", leadDate.toISOString(), "range:", startDate.toISOString(), "to", rangeEnd.toISOString());
      }
      return inRange;
    });

    console.log("[YTD NM DEBUG] ytdLeads count:", ytdLeads.length);
    setFilteredLeadByYear(ytdLeads);
  }, [searchedLeadReportswithoutyears, selectedYears, isCrmPackage]);

  // Helper function to convert month name to index (0-11)
  const getMonthIndex = (monthName) => {
    const months = {
      jan: 0, january: 0,
      feb: 1, february: 1,
      mar: 2, march: 2,
      apr: 3, april: 3,
      may: 4,
      jun: 5, june: 5,
      jul: 6, july: 6,
      aug: 7, august: 7,
      sep: 8, september: 8,
      oct: 9, october: 9,
      nov: 10, november: 10,
      dec: 11, december: 11
    };

    return months[monthName.toLowerCase()] !== undefined
      ? months[monthName.toLowerCase()]
      : -1;
  };

  const [totalGrossProfit, settotalGrossProfit] = useState("");
  const [taxcostnormal, setTaxCostNormal] = useState("");
  const [taxcostYTD, setTaxCostYTD] = useState("");

  const [GandACostNormal, setGandACostNormal] = useState("");
  const [GandACostYTDcurrent, setGandACostYTDcurrent] = useState("");

  const [netMargin, setnetMargin] = useState("");
  const [netMarginPercentage, setnetMarginPercentage] = useState("");

  const [totalGrossProfitCurrent, settotalGrossProfitCurrent] = useState("");
  const [netMarginCurrent, setnetMarginCurrent] = useState("");
  const [netMarginPercentageCurrent, setnetMarginPercentageCurrent] = useState("");
  const { taxes } = useSelector((state) => state.salesTaxes);


  // for Normal
  useEffect(() => {
    const parseNum = (v) => parseFloat(String(v || "0").replace(/,/g, "")) || 0;

    let GandATax = 15;
    let taxPct = 27;
    const filteredTaxes = currentEmployee?._id
      ? taxes?.filter((t) => t.createdBy === currentEmployee._id)
      : taxes;
    filteredTaxes?.forEach((data) => {
      if (data.taxName === "G&A Expenses") GandATax = data.taxPercentage;
      if (data.taxName === "Tax") taxPct = data.taxPercentage;
    });

    const allLeads = searchedLeadReports || [];

    // CRM: Total Net Margin must use the same Total Gross Profit as Total Gross Profit card.
    // Reuse P&L table row values when provided so field names always match.
    const selectedGrossProfitYear = (() => {
      const s = String((selectedYears && selectedYears[0]) || "").trim();
      const m = s.match(/^(\d{4})/);
      return m ? Number(m[1]) : null;
    })();

    const canUseAccessorsForCrmTotal =
      isCrmPackage &&
      showTable !== "Actual" &&
      typeof plGetQuotedValueForRow === "function" &&
      typeof plGetQuotedExpenseForRow === "function" &&
      selectedGrossProfitYear != null;

    if (canUseAccessorsForCrmTotal) {
      const getLeadDate = (row) => {
        const raw =
          row?.lead_date ||
          row?.leadDate ||
          row?.LeadDate ||
          row?.created_at ||
          row?.createdAt;
        if (!raw) return null;
        const normalized = ValidDate(raw);
        if (normalized) {
          const [y, m, d] = normalized.split("-").map(Number);
          const dt = new Date(y, m - 1, d);
          return isNaN(dt.getTime()) ? null : dt;
        }
        const dt = new Date(raw);
        return isNaN(dt.getTime()) ? null : dt;
      };

      const totalRows = (searchedLeadReportswithoutyears || []).filter((row) => {
        const dt = getLeadDate(row);
        if (!dt) return false;
        return dt.getFullYear() === selectedGrossProfitYear;
      });

      const totalQuotedValue = totalRows.reduce(
        (sum, row) => sum + (Number(plGetQuotedValueForRow(row)) || 0),
        0
      );
      const productcost = totalRows.reduce(
        (sum, row) => sum + (Number(plGetQuotedExpenseForRow(row)) || 0),
        0
      );

      const grossProfit = totalQuotedValue - productcost;
      const GandAcostRaw = grossProfit * (GandATax / 100);
      const GandAcost = isCrmPackage ? Math.round(GandAcostRaw) : GandAcostRaw;
      const taxBase = grossProfit;
      const taxcostRaw = taxBase * (taxPct / 100);
      const taxcost = isCrmPackage ? Math.round(taxcostRaw) : taxcostRaw;
      const netrevenue = grossProfit - GandAcost - taxcost;
      const netMarginPct = totalQuotedValue > 0 ? (netrevenue / totalQuotedValue) * 100 : 0;

      setTaxCostNormal(taxcost);
      setGandACostNormal(GandAcost);
      settotalGrossProfit(grossProfit);
      settotalProductCost(productcost);
      setnetMargin(netrevenue);
      setnetMarginPercentage(netMarginPct);
      return;
    }

    if (showTable === "Actual") {
      const actualLeads = (getActualProjectCost && getRowKey)
        ? allLeads.filter((lead) => getActualProjectCost(getRowKey(lead)) !== 0)
        : [];

      if (actualLeads.length === 0) {
        settotalGrossProfit(0);
        setnetMargin(0);
        setnetMarginPercentage(0);
        return;
      }

      let totalQuotedValue = 0;
      let totalActualCost = 0;
      actualLeads.forEach((r) => {
        totalQuotedValue += parseNum(r.quotedPrice ?? r.QuotedValue);
        totalActualCost += getActualProjectCost(getRowKey(r));
      });
      const grossProfit = totalQuotedValue - totalActualCost;
      const GandAcost = grossProfit * (GandATax / 100);
      const EBTcost = grossProfit - GandAcost;
      const taxcost = grossProfit * (taxPct / 100);
      const netrevenue = EBTcost - taxcost;
      const netMarginPct = totalQuotedValue > 0 ? (netrevenue / totalQuotedValue) * 100 : 0;

      setTaxCostNormal(taxcost);
      setGandACostNormal(GandAcost);
      settotalGrossProfit(grossProfit);
      settotalProductCost(totalActualCost);
      setnetMargin(netrevenue);
      setnetMarginPercentage(netMarginPct);
      return;
    }

    const quotedLeads = isCrmPackage
      ? allLeads
      : ((getProjectCost && getRowKey)
        ? allLeads.filter((lead) => getProjectCost(getRowKey(lead)) !== 0)
        : []);

    const usePlTotals =
      showTable !== "Actual" &&
      erpPlGrossProfitSumForCard != null &&
      Number.isFinite(Number(erpPlGrossProfitSumForCard)) &&
      erpPlValueSumForCard != null &&
      Number.isFinite(Number(erpPlValueSumForCard)) &&
      erpPlCostSumForCard != null &&
      Number.isFinite(Number(erpPlCostSumForCard));

    if (!usePlTotals && quotedLeads.length === 0) {
      settotalGrossProfit(0);
      setnetMargin(0);
      setnetMarginPercentage(0);
      return;
    }

    const { totalQuotedValue: reducedQV, productcost: reducedPC } = usePlTotals
      ? { totalQuotedValue: 0, productcost: 0 }
      : quotedLeads.reduce((acc, r) => {
        acc.totalQuotedValue += parseNum(r.quotedPrice ?? r.QuotedValue);
        if (isCrmPackage) {
          const expenseVal = parseExpenseValue(r.quotedExpense ?? r.QuotedExpense ?? r.quotedExpenses ?? 0);
          if (expenseVal > 0) acc.productcost += expenseVal;
        } else {
          acc.productcost += getProjectCost(getRowKey(r));
        }
        return acc;
      }, { totalQuotedValue: 0, productcost: 0 });

    const totalQuotedValue = usePlTotals ? Number(erpPlValueSumForCard) : reducedQV;
    const productcost = usePlTotals ? Number(erpPlCostSumForCard) : reducedPC;
    const grossProfitRaw = usePlTotals ? Number(erpPlGrossProfitSumForCard) : reducedQV - reducedPC;
    const grossProfit = isCrmPackage ? Math.round(grossProfitRaw) : grossProfitRaw;
    const GandAcostRaw = grossProfit * (GandATax / 100);
    const GandAcost = isCrmPackage ? Math.round(GandAcostRaw) : GandAcostRaw;
    // CRM rule: Tax must be calculated on full Total Gross Profit.
    const taxBase = grossProfit;
    const taxcostRaw = taxBase * (taxPct / 100);
    const taxcost = isCrmPackage ? Math.round(taxcostRaw) : taxcostRaw;
    const netrevenue = grossProfit - GandAcost - taxcost;
    // Net Margin (%) must always be based on quoted Value (₹), even for CRM.
    const netMarginPct = totalQuotedValue > 0 ? (netrevenue / totalQuotedValue) * 100 : 0;

    if (Math.round(netrevenue) !== Math.round(grossProfit - GandAcost - taxcost)) {
      console.warn("[CRM NET MARGIN VALIDATION] Total Net Margin mismatch detected.");
    }
    setTaxCostNormal(taxcost);
    setGandACostNormal(GandAcost);
    settotalGrossProfit(grossProfit);
    settotalProductCost(productcost);
    setnetMargin(netrevenue);
    setnetMarginPercentage(netMarginPct);

  }, [
    showTable,
    packages,
    isCrmPackage,
    calculatedProjects,
    taxes,
    averagecost,
    perdiem,
    quotationProjects,
    searchedLeadReports,
    searchedLeadReportswithoutyears,
    getProjectCost,
    getActualProjectCost,
    getRowKey,
    currentEmployee,
    erpPlGrossProfitSumForCard,
    erpPlValueSumForCard,
    erpPlCostSumForCard,
    plGetQuotedValueForRow,
    plGetQuotedExpenseForRow,
    selectedYears,
  ]);



  // for YTD
  useEffect(() => {
    const parseNum = (v) => parseFloat(String(v || "0").replace(/,/g, "")) || 0;
    const allYearLeads = filteredLeadByYear || [];

    const selectedPeriod = String(selectedYears?.[0] ?? "").trim();
    const monthMatchYTD = selectedPeriod.match(/^(\d{4})\s+([A-Za-z]+)$/);
    const quarterMatchYTD = selectedPeriod.match(/^(\d{4})\s+([A-Za-z]+)\s*-\s*([A-Za-z]+)$/);

    let ytdOnly;

    // CRM (hard align to P&L rows + GP YEAR):
    // If we have the P&L-rendered rows + accessors, compute YTD Net Margin only from those rows.
    // - Always filter by selected gross profit year
    // - Apply special cutoff only for year 2025 (<= 8 May 2025)
    const selectedGrossProfitYear = (() => {
      const m = String(selectedPeriod).match(/^(\d{4})/);
      return m ? Number(m[1]) : null;
    })();
    const canUseAccessorsForCrmYtd =
      isCrmPackage &&
      showTable !== "Actual" &&
      typeof plGetQuotedValueForRow === "function" &&
      typeof plGetQuotedExpenseForRow === "function" &&
      selectedGrossProfitYear != null;

    if (isCrmPackage) {
      ytdOnly = allYearLeads;
    } else if (monthMatchYTD || quarterMatchYTD) {
      ytdOnly = allYearLeads;
    } else {
      const today = new Date();
      const yearMatch = selectedPeriod.match(/^(\d{4})/);
      const selYear = yearMatch ? Number(yearMatch[1]) : today.getFullYear();

      const toDateNum = (y, m, d) => y * 10000 + m * 100 + d;
      const ytdCutoffNum = toDateNum(selYear, today.getMonth() + 1, today.getDate());

      const getLeadDateNum = (raw) => {
        if (!raw) return null;
        const str = String(raw).trim();

        if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
          const [y, m, d] = str.split("-").map(Number);
          return toDateNum(y, m, d);
        }

        const dmyMatch = str.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
        if (dmyMatch) {
          const p1 = Number(dmyMatch[1]), p2 = Number(dmyMatch[2]), yr = Number(dmyMatch[3]);
          let day, month;
          if (p1 > 12) { day = p1; month = p2; }
          else if (p2 > 12) { month = p1; day = p2; }
          else { day = p1; month = p2; }
          return toDateNum(yr, month, day);
        }

        const parsed = new Date(str);
        if (!isNaN(parsed.getTime())) {
          return toDateNum(parsed.getFullYear(), parsed.getMonth() + 1, parsed.getDate());
        }
        return null;
      };

      ytdOnly = allYearLeads.filter((lead) => {
        const num = getLeadDateNum(lead.LeadDate);
        return num != null && num <= ytdCutoffNum;
      });
    }

    let GandATax = 15;
    let taxPct = 27;
    const ytdFilteredTaxes = currentEmployee?._id
      ? taxes?.filter((t) => t.createdBy === currentEmployee._id)
      : taxes;
    ytdFilteredTaxes?.forEach((data) => {
      if (data.taxName === "G&A Expenses") GandATax = data.taxPercentage;
      if (data.taxName === "Tax") taxPct = data.taxPercentage;
    });

    const yearOnlyMatchForYtd = selectedPeriod.match(/^(\d{4})$/);
    const selectedYearForYtd = yearOnlyMatchForYtd ? Number(yearOnlyMatchForYtd[1]) : null;

    const applyYtdNetMarginFromTotals = (totalQuotedValue, productcost, grossProfit) => {
      const gp = isCrmPackage ? Math.round(grossProfit) : grossProfit;
      const GandAcostRaw = gp * (GandATax / 100);
      const GandAcost = isCrmPackage ? Math.round(GandAcostRaw) : GandAcostRaw;
      const taxcostRaw = gp * (taxPct / 100);
      const taxcost = isCrmPackage ? Math.round(taxcostRaw) : taxcostRaw;
      const netrevenue = gp - GandAcost - taxcost;
      const netMarginPct = totalQuotedValue > 0 ? (netrevenue / totalQuotedValue) * 100 : 0;

      setGandACostYTDcurrent(GandAcost);
      setTaxCostYTD(taxcost);
      settotalGrossProfitCurrent(gp);
      setYTDtotalProductCostCurrent(productcost);
      setnetMarginCurrent(netrevenue);
      setnetMarginPercentageCurrent(netMarginPct);
    };

    if (canUseAccessorsForCrmYtd) {
      const endOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
      const cutoff =
        selectedGrossProfitYear === 2025 ? endOfDay(new Date(2025, 4, 8)) : null; // 8 May 2025

      const getLeadDate = (row) => {
        const raw =
          row?.lead_date ||
          row?.leadDate ||
          row?.LeadDate ||
          row?.created_at ||
          row?.createdAt;
        if (!raw) return null;
        const normalized = ValidDate(raw);
        if (normalized) {
          const [y, m, d] = normalized.split("-").map(Number);
          const dt = new Date(y, m - 1, d);
          return isNaN(dt.getTime()) ? null : dt;
        }
        const dt = new Date(raw);
        return isNaN(dt.getTime()) ? null : dt;
      };

      const ytdRows = (searchedLeadReportswithoutyears || []).filter((row) => {
        const dt = getLeadDate(row);
        if (!dt) return false;
        if (dt.getFullYear() !== selectedGrossProfitYear) return false;
        if (cutoff) return dt <= cutoff;
        return true;
      });

      const totalQuotedValue = ytdRows.reduce(
        (sum, row) => sum + (Number(plGetQuotedValueForRow(row)) || 0),
        0
      );
      const productcost = ytdRows.reduce(
        (sum, row) => sum + (Number(plGetQuotedExpenseForRow(row)) || 0),
        0
      );
      const grossProfit = totalQuotedValue - productcost;
      const GandAcostRaw = grossProfit * (GandATax / 100);
      const GandAcost = isCrmPackage ? Math.round(GandAcostRaw) : GandAcostRaw;
      const taxBase = grossProfit;
      const taxcostRaw = taxBase * (taxPct / 100);
      const taxcost = isCrmPackage ? Math.round(taxcostRaw) : taxcostRaw;
      const netrevenue = grossProfit - GandAcost - taxcost;
      const netMarginPct = totalQuotedValue > 0 ? (netrevenue / totalQuotedValue) * 100 : 0;

      setGandACostYTDcurrent(GandAcost);
      setTaxCostYTD(taxcost);
      settotalGrossProfitCurrent(grossProfit);
      setYTDtotalProductCostCurrent(productcost);
      setnetMarginCurrent(netrevenue);
      setnetMarginPercentageCurrent(netMarginPct);
      return;
    }

    // CRM current year (year-only): YTD Net Margin must match YTD Gross Profit card (same as Total).
    const isCurrentYearOnlyCrm =
      isCrmPackage &&
      showTable !== "Actual" &&
      selectedYearForYtd != null &&
      selectedYearForYtd === new Date().getFullYear();
    if (isCurrentYearOnlyCrm && selectedYearForYtd !== 2025) {
      const ytdValue =
        erpPlValueSumForCard != null && Number.isFinite(Number(erpPlValueSumForCard))
          ? Number(erpPlValueSumForCard)
          : Number(totalGrossProfit) + Number(totalProductCost);
      const ytdCost = Number(totalProductCost) || 0;
      const ytdGp = Number(totalGrossProfit) || 0;
      if (Number.isFinite(ytdValue) && Number.isFinite(ytdGp)) {
        applyYtdNetMarginFromTotals(ytdValue, ytdCost, ytdGp);
        return;
      }
    }

    // ERP current year (year-only): YTD Net Margin must use the same P&L-aligned totals as YTD Gross Profit card.
    const isCurrentYearOnlyErp =
      !isCrmPackage &&
      showTable !== "Actual" &&
      selectedYearForYtd != null &&
      selectedYearForYtd === new Date().getFullYear();
    const hasPandlTotalsForYtd =
      erpPlGrossProfitSumForCard != null &&
      Number.isFinite(Number(erpPlGrossProfitSumForCard)) &&
      erpPlValueSumForCard != null &&
      Number.isFinite(Number(erpPlValueSumForCard)) &&
      erpPlCostSumForCard != null &&
      Number.isFinite(Number(erpPlCostSumForCard));

    if (isCurrentYearOnlyErp && hasPandlTotalsForYtd) {
      applyYtdNetMarginFromTotals(
        Number(erpPlValueSumForCard),
        Number(erpPlCostSumForCard),
        Number(erpPlGrossProfitSumForCard)
      );
      return;
    }

    if (showTable === "Actual") {
      const actualLeads = (getActualProjectCost && getRowKey)
        ? ytdOnly.filter((lead) => getActualProjectCost(getRowKey(lead)) !== 0)
        : [];

      if (actualLeads.length === 0) {
        settotalGrossProfitCurrent(0);
        setnetMarginCurrent(0);
        setnetMarginPercentageCurrent(0);
        return;
      }

      let totalQuotedValue = 0;
      let totalActualCost = 0;
      actualLeads.forEach((r) => {
        totalQuotedValue += parseNum(r.quotedPrice ?? r.QuotedValue);
        totalActualCost += getActualProjectCost(getRowKey(r));
      });
      const grossProfit = totalQuotedValue - totalActualCost;
      const GandAcost = grossProfit * (GandATax / 100);
      const EBTcost = grossProfit - GandAcost;
      const taxcost = grossProfit * (taxPct / 100);
      const netrevenue = EBTcost - taxcost;
      const netMarginPct = totalQuotedValue > 0 ? (netrevenue / totalQuotedValue) * 100 : 0;

      setGandACostYTDcurrent(GandAcost);
      setTaxCostYTD(taxcost);
      settotalGrossProfitCurrent(grossProfit);
      setYTDtotalProductCostCurrent(totalActualCost);
      setnetMarginCurrent(netrevenue);
      setnetMarginPercentageCurrent(netMarginPct);
      return;
    }

    const ytdLeads = isCrmPackage
      ? ytdOnly
      : ((getProjectCost && getRowKey)
        ? ytdOnly.filter((lead) => getProjectCost(getRowKey(lead)) !== 0)
        : []);

    const usePlYtd =
      showTable !== "Actual" &&
      erpPlYtdGrossProfitForNetMargin != null &&
      Number.isFinite(Number(erpPlYtdGrossProfitForNetMargin)) &&
      erpPlYtdQuotedValueForNetMargin != null &&
      Number.isFinite(Number(erpPlYtdQuotedValueForNetMargin)) &&
      erpPlYtdProductCostForNetMargin != null &&
      Number.isFinite(Number(erpPlYtdProductCostForNetMargin));

    if (!usePlYtd && ytdLeads.length === 0) {
      settotalGrossProfitCurrent(0);
      setnetMarginCurrent(0);
      setnetMarginPercentageCurrent(0);
      return;
    }

    const { totalQuotedValue: ytdReducedQV, productcost: ytdReducedPC } = usePlYtd
      ? { totalQuotedValue: 0, productcost: 0 }
      : ytdLeads.reduce((acc, r) => {
        acc.totalQuotedValue += parseNum(r.quotedPrice ?? r.QuotedValue);
        if (isCrmPackage) {
          const expenseVal = parseExpenseValue(r.quotedExpense ?? r.QuotedExpense ?? r.quotedExpenses ?? 0);
          if (expenseVal > 0) acc.productcost += expenseVal;
        } else {
          acc.productcost += getProjectCost(getRowKey(r));
        }
        return acc;
      }, { totalQuotedValue: 0, productcost: 0 });

    const totalQuotedValue = usePlYtd ? Number(erpPlYtdQuotedValueForNetMargin) : ytdReducedQV;
    const productcost = usePlYtd ? Number(erpPlYtdProductCostForNetMargin) : ytdReducedPC;
    const grossProfitRaw = usePlYtd ? Number(erpPlYtdGrossProfitForNetMargin) : ytdReducedQV - ytdReducedPC;
    const grossProfit = isCrmPackage ? Math.round(grossProfitRaw) : grossProfitRaw;
    const GandAcostRaw = grossProfit * (GandATax / 100);
    const GandAcost = isCrmPackage ? Math.round(GandAcostRaw) : GandAcostRaw;
    const taxBase = grossProfit;
    const taxcostRaw = taxBase * (taxPct / 100);
    const taxcost = isCrmPackage ? Math.round(taxcostRaw) : taxcostRaw;
    const netrevenue = grossProfit - GandAcost - taxcost;
    // YTD Net Margin (%) must always be based on quoted YTD Value (₹), even for CRM.
    const netMarginPct = totalQuotedValue > 0 ? (netrevenue / totalQuotedValue) * 100 : 0;

    if (Math.round(netrevenue) !== Math.round(grossProfit - GandAcost - taxcost)) {
      console.warn("[CRM NET MARGIN VALIDATION] YTD Net Margin mismatch detected.");
    }
    setGandACostYTDcurrent(GandAcost);
    setTaxCostYTD(taxcost);
    settotalGrossProfitCurrent(grossProfit);
    setYTDtotalProductCostCurrent(productcost);
    setnetMarginCurrent(netrevenue);
    setnetMarginPercentageCurrent(netMarginPct);

  }, [
    showTable,
    packages,
    isCrmPackage,
    netMargin,
    calculatedProjects,
    taxes,
    averagecost,
    perdiem,
    quotationProjects,
    filteredLeadByYear,
    searchedLeadReports,
    searchedLeadReportswithoutyears,
    selectedYears,
    getProjectCost,
    getActualProjectCost,
    getRowKey,
    currentEmployee,
    totalGrossProfit,
    totalProductCost,
    erpPlGrossProfitSumForCard,
    erpPlValueSumForCard,
    erpPlCostSumForCard,
    erpPlYtdGrossProfitForNetMargin,
    erpPlYtdQuotedValueForNetMargin,
    erpPlYtdProductCostForNetMargin,
    plGetQuotedValueForRow,
    plGetQuotedExpenseForRow,
  ]);

  const [probabilityTab, setProbabilityTab] = useState("graph");
  const [YTD, setYTD] = useState("graph");

  useEffect(() => {
    if (probabilityTab === "graph" && !canViewNetMarginGraph && canViewNetMarginTable) {
      setProbabilityTab("table");
    } else if (probabilityTab === "table" && !canViewNetMarginTable && canViewNetMarginGraph) {
      setProbabilityTab("graph");
    }
  }, [probabilityTab, canViewNetMarginGraph, canViewNetMarginTable]);

  useEffect(() => {
    if (YTD === "graph" && !canViewYtdNetMarginGraph && canViewYtdNetMarginTable) {
      setYTD("table");
    } else if (YTD === "table" && !canViewYtdNetMarginTable && canViewYtdNetMarginGraph) {
      setYTD("graph");
    }
  }, [YTD, canViewYtdNetMarginGraph, canViewYtdNetMarginTable]);

  useEffect(() => {
    if (filterVersion == null) return;
    setProbabilityTab("graph");
    setYTD("graph");
  }, [filterVersion]);


  const numericPercentage = Number(netMarginPercentage);


  let adjustedPercentage = 0;
  // if (numericPercentage < 0) {
  //   adjustedPercentage = -0.125;
  // } else 
  if (numericPercentage <= 10) {
    adjustedPercentage = 0.125;
  } else if (numericPercentage <= 20) {
    adjustedPercentage = 0.375;
  } else if (numericPercentage <= 30) {
    adjustedPercentage = 0.625;
  } else {
    adjustedPercentage = 0.875;
  }

  let adjustedPercentage2 = 0;

  // if (totalPercentageCurrent < 0) {
  //   adjustedPercentage2 = -0.125; // Negative range (e.g. for lower red arc)
  // } else 
  if (netMarginPercentageCurrent <= 10) {
    adjustedPercentage2 = 0.125; // Center of 1st segment (Red)
  } else if (netMarginPercentageCurrent <= 20) {
    adjustedPercentage2 = 0.375; // Center of 2nd segment (Orange)
  } else if (netMarginPercentageCurrent <= 30) {
    adjustedPercentage2 = 0.625; // Center of 3rd segment (Yellow)
  } else {
    adjustedPercentage2 = 0.875; // Center of 4th segment (Green)
  }

  // Memoize GaugeChart elements so they don't re‑mount and "pulse"
  // when unrelated state in this component changes.
  const netMarginGauge = React.useMemo(
    () => (
      <GaugeChart
        cornerRadius={3}
        id="gauge-chart-net-margin"
        nrOfLevels={10}
        percent={adjustedPercentage}
        textColor="#000"
        hideText={true}
        arcsLength={[0.25, 0.25, 0.25, 0.25]}
        colors={["#f36820", "#fbd006", "#4bb647", "#15803d"]}
        style={{
          width: "120%",
          height: "50%",
          marginTop: "-12%",
        }}
        needleBase={25}
        arcPadding={0.01}
        animate={false}
      />
    ),
    [adjustedPercentage]
  );

  const ytdNetMarginGauge = React.useMemo(
    () => (
      <GaugeChart
        id="gauge-chart-ytd-net-margin"
        nrOfLevels={10}
        percent={adjustedPercentage2}
        textColor="#000"
        hideText={true}
        arcsLength={[0.25, 0.25, 0.25, 0.25]}
        colors={["#f36820", "#fbd006", "#4bb647", "#15803d"]}
        style={{
          width: "120%",
          height: "50%",
          marginTop: "-12%",
        }}
        cornerRadius={3}
        needleBase={20}
        arcPadding={0.01}
        animate={false}
      />
    ),
    [adjustedPercentage2]
  );

  // For CRM, 0 is a valid result when rows exist (e.g., Value == Cost ⇒ GP == 0).
  // Do NOT hide the gauge/table just because computed numbers are 0.
  const hasRowsForTotal = Array.isArray(searchedLeadReports) && searchedLeadReports.length > 0;
  const hasRowsForYtd = Array.isArray(filteredLeadByYear) && filteredLeadByYear.length > 0;
  const canRenderTotalContent =
    (isCrmPackage ? hasRowsForTotal : Boolean(totalGrossProfit && totalProductCost));
  const canRenderYtdContent =
    (isCrmPackage
      ? (hasRowsForYtd && Number(totalGrossProfitCurrent) !== 0)
      : Boolean(totalGrossProfitCurrent && ytdtotalProductCostCurrent));

  return (
    <div className="flex w-full h-full gap-2 ">
      {(canViewNetMarginGraph || canViewNetMarginTable) && (
      <div className="h-full w-1/2 bg-white rounded-md p-2 z-10">
        <div className="h-[10%]">
          <div className="flex flex-wrap justify-start items-center xl:flex xl:justify-between md:justify-between md:flex-nowrap ">
            <div>
              <h2 className="text-lg font-semibold sm:text-sm md:text-sm lg:text-lg">
                Net Margin
              </h2>
            </div>

            <div className="md:flex lg:ml-8 lg:flex lg:items-center lg:justify-end xl:flex xl:justify-end ">
              <div className="show-potential-download lg:justify-end">
                <div className=" flex items-center justify-between text-3xl sm:text-xl md:text-md">
                  {probabilityTab === "table" && canViewNetMarginGraph && (
                    <span title="Graph">
                      <ChartColumnDecreasing
                        className="cursor-pointer text-blue-600"
                        onClick={() => setProbabilityTab("graph")}
                        fontSize="3rem"
                      />
                    </span>
                  )}
                  {probabilityTab === "graph" && canViewNetMarginTable && (
                    <span title="Table">
                      <TableOfContents
                        className="cursor-pointer text-blue-600"
                        onClick={() => setProbabilityTab("table")}
                        fontSize="3rem"
                      />
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* <hr />
            <hr /> */}
        </div>

        <div className="h-[14rem] flex overflow-hidden ">
          {(probabilityTab === "table" && canViewNetMarginTable) || !canViewNetMarginGraph ? (
            canRenderTotalContent ? (
              <div className="w-full pt-3">
                <div className="overflow-auto border border-black">
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black border-b border-black px-2 py-1">
                      <p className="text-xs break-words whitespace-normal">Total Gross Profit ({currency})</p>
                    </div>
                    <div className="w-[40%] text-center  border-b border-black px-2 py-1">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center"> {USAComma(totalGrossProfit)}</p>
                    </div>
                  </div>
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black border-b border-black px-2 py-1">
                      <p className="text-xs break-words whitespace-normal">Total G & A Cost ({currency})</p>
                    </div>
                    <div className="w-[40%] text-center border-b border-black px-2 py-1">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center">{USAComma(GandACostNormal)}</p>
                    </div>
                  </div>
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black border-b border-black px-2 py-1">
                      <p className="text-xs break-words whitespace-normal">Tax ({currency})</p>
                    </div>
                    <div className="w-[40%] text-center border-b border-black px-2 py-1">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center"> {USAComma(taxcostnormal)}</p>
                    </div>
                  </div>
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black border-b border-black px-2 py-1">
                      <p className="text-xs break-words whitespace-normal">Total Net Margin ({currency})</p>
                    </div>
                    <div className="w-[40%] text-center border-b border-black px-2 py-1">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center"> {USAComma(netMargin)}</p>
                    </div>
                  </div>
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black  px-2 py-1">
                      <p className="text-xs break-words whitespace-normal">Total Net Margin (%)</p>
                    </div>
                    <div className="w-[40%] text-center  px-2 py-1">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center">{formatPct(netMarginPercentage)}</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex justify-center align-middle items-center text-center mb-5  w-full">
                <p className="noDataAvailable">No data available</p>{" "}
              </div>
            )
          ) : (canViewNetMarginGraph && canRenderTotalContent) ? (

            // <div className="w-full h-[14rem] flex flex-col justify-start items-start ">
            //     <div className="w-full h-[70%] flex justify-start items-start z-[499]">
            //       <RadialGauge value={netMarginPercentage} secondaryText={80} />
            //     </div>
            //     <div className="z-[999] h-[10%] -mt-4 xl:pt-2 td:pt-0 cp:pt-0 text-center w-[100%] ">
            //       {USAComma(netMarginPercentage)}%
            //     </div>
            //   </div>

            <div className=" w-full flex justify-center items-center h-[16rem] sm:h-[16rem] md:h-[16rem] lg:h-[16rem]">
              <div className="flex flex-col " style={{ width: "100%", height: "100%", display: "flex-col", justifyContent: "center", alignItems: "center" }}>
                {netMarginGauge}
                <div className="h-10 pt-2 xl:pt-2 td:pt-3 cp:pt-4 text-center w-[100%] ">
                  {formatPct(netMarginPercentage)}%
                </div>
              </div>
            </div>
          ) : (
            <div className="flex justify-center align-middle items-center text-center mb-5  w-full">
              <p className="noDataAvailable">No data available</p>{" "}
            </div>
          )}
        </div>
      </div>
      )}

      {(canViewYtdNetMarginGraph || canViewYtdNetMarginTable) && (
      <div className="h-full w-1/2 bg-white rounded-md p-2">
        <div className="h-[10%]">
          <div className="flex flex-wrap justify-start items-center xl:flex xl:justify-between md:justify-between md:flex-nowrap ">
            <div>
              <h2 className="text-lg font-semibold sm:text-sm md:text-sm lg:text-lg">
                YTD Net Margin
              </h2>
            </div>

            <div className="md:flex lg:ml-8 lg:flex lg:items-center lg:justify-end xl:flex xl:justify-end ">
              <div className="show-potential-download lg:justify-end">
                <div className=" flex items-center justify-between text-3xl sm:text-xl md:text-md pr-2">
                  {YTD === "table" && canViewYtdNetMarginGraph && (
                    <span title="Graph">
                      <ChartColumnDecreasing
                        className="cursor-pointer text-blue-600"
                        onClick={() => setYTD("graph")}
                        fontSize="3rem"
                      />
                    </span>
                  )}
                  {YTD === "graph" && canViewYtdNetMarginTable && (
                    <span title="Table">
                      <TableOfContents
                        className="cursor-pointer text-blue-600"
                        onClick={() => setYTD("table")}
                        fontSize="3rem"
                      />
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* <hr />
            <hr /> */}
        </div>

        <div className="h-[14rem] flex overflow-hidden">
          {(YTD === "table" && canViewYtdNetMarginTable) || !canViewYtdNetMarginGraph ? (
            canRenderYtdContent ? (
              <div className="w-full pt-3">
                <div className="overflow-auto border border-black">
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black border-b border-black px-2 py-1">
                      <p className="text-xs break-words whitespace-normal">YTD Gross Profit ({currency})</p>
                    </div>
                    <div className="w-[40%] text-center   px-2 py-1 border-b border-black">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center"> {USAComma(totalGrossProfitCurrent)}</p>
                    </div>
                  </div>
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black border-b border-black px-2 py-1">
                      <p className="text-xs break-words whitespace-normal">YTD G & A Cost ({currency})</p>
                    </div>
                    <div className="w-[40%] text-center   px-2 py-1 border-b border-black">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center">{USAComma(GandACostYTDcurrent)}</p>
                    </div>
                  </div>
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black border-b border-black px-2 py-1">
                      <p className="text-xs break-words whitespace-normal"> Tax ({currency})</p>
                    </div>
                    <div className="w-[40%] text-center  px-2 py-1 border-b border-black">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center">{USAComma(taxcostYTD)}</p>
                    </div>
                  </div>
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black border-b border-black px-2 py-1">
                      <p className="text-xs break-words whitespace-normal">YTD Net Margin ({currency})</p>
                    </div>
                    <div className="w-[40%] text-center px-2 py-1 border-b border-black">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center"> {USAComma(netMarginCurrent)}</p>
                    </div>
                  </div>
                  <div className="w-full flex">
                    <div className="w-[60%] text-start font-semibold bg-[#e8e8e8] text-black px-2 py-1">
                      <p className="text-xs break-words whitespace-normal">YTD Net Margin (%)</p>
                    </div>
                    <div className="w-[40%] text-center px-2 py-1">
                      <p className="text-xs break-all whitespace-normal flex justify-start items-center">
                        {formatPct(netMarginPercentageCurrent)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex justify-center align-middle items-center text-center mb-5  w-full">
                <p className="noDataAvailable">No data available</p>{" "}
              </div>
            )
          ) : (canViewYtdNetMarginGraph && canRenderYtdContent) ? (

            // <div className="w-full h-[14rem] flex flex-col justify-start items-start">
            //   <div className="w-full h-[70%] flex justify-start items-start z-[499]">
            //     <RadialGauge value={netMarginPercentageCurrent}  />
            //   </div>
            //   <div className="z-[999] h-[10%] -mt-4 xl:pt-2 td:pt-0 cp:pt-0 text-center w-[100%] ">
            //     {USAComma(netMarginPercentageCurrent)}%
            //   </div>
            // </div>

            <div className=" w-full flex flex-col justify-center items-center h-[16rem] sm:h-[16rem] md:h-[16rem] lg:h-[16rem] ">
              <div className="relative flex flex-col " style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                {ytdNetMarginGauge}
                <div className="h-10 pt-2 xl:pt-2 td:pt-3 cp:pt-4 text-center w-[100%]">
                  {formatPct(netMarginPercentageCurrent)}%
                </div>
              </div>
            </div>
          ) : (
            <div className="flex justify-center align-middle items-center text-center mb-5  w-full">
              <p className="noDataAvailable">No data available</p>{" "}
            </div>
          )}
        </div>
      </div>
      )}
    </div>
  );
};

export default SearchedSalesNetMargin;
